<template>
    <AlertMessage
        type="tip"
        class="flex-fill"
        innerclass="flex-fill"
        :dismissforever="true"
        :dismisskey="message"
        :globalmessage="true"
        :fulldismiss-button="true"
    >
        <h6 class="mb-3 fs-5 flex-fill">{{ $tm('didyouknow.header') }}</h6>
        <hr />

        <slot><div v-html="$tm(message, '', true)"></div></slot>
    </AlertMessage>
</template>
<script setup lang="ts">
import { AlertMessage } from '@/components';

const props = defineProps<{
    /**
     * If we should show the messages or not
     * @default true
     */
    message: string;
}>();
</script>
